import {
  encryptData,
  decryptData,
  encryptChatbotData,
  decryptChatbotData,
} from "./utils/cryptoutils";

/** Gateway + chatbot encryption: true = AES-GCM, false = plain URLs and JSON */
// const ENABLE_API_ENCRYPTION = false;
const host = window.location.host;
// const host = "https://kemis-helpdesk-pro.dhanushinfotech.com";
// const host = "https://helpdesk-pro.dhanushinfotech.com";

const ENABLE_API_ENCRYPTION =
  host.includes("kemis-helpdesk-pro.dhanushinfotech.com") ||
  host.includes("helpdesk.kemis.go.ke");

// console.log("ENABLE_API_ENCRYPTION", ENABLE_API_ENCRYPTION);


const CHATBOT_API_ENCRYPTION_KEY =
  process.env.REACT_APP_CHATBOT_API_ENCRYPTION_KEY || "chatbot@transport";

export const isApiEncryptionEnabled = () => ENABLE_API_ENCRYPTION;

const getBaseUrl = () => {

  const hostname = window.location.hostname;

  const protocol = window.location.protocol;

  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {

    return 'http://localhost:8080';
    // return 'https://helpdesk-pro.dhanushinfotech.com';
    // return 'https://kemis-helpdesk-pro.dhanushinfotech.com';

  } else {

    return `${protocol}//${hostname}`;

  }

};

const BASE_URL = getBaseUrl();

export async function apiRequest(endpoint, {

  method = "GET",

  body,

  headers = {},

  timeout = 60000,

  params

} = {}) {

  const controller = new AbortController();

  const id = setTimeout(() => controller.abort(), timeout);

  const token =

    sessionStorage.getItem("token") ||

    sessionStorage.getItem("authToken") ||

    localStorage.getItem("token") ||

    localStorage.getItem("authToken");

  try {

    // ================= ENCRYPTION LOGIC (UNCHANGED) =================

    let fullRouteToEncrypt = endpoint;

    if (endpoint.startsWith('/gateway/')) {

      fullRouteToEncrypt = endpoint.substring('/gateway/'.length);

    } else if (endpoint.startsWith('/')) {

      fullRouteToEncrypt = endpoint.substring(1);

    }

    if (params && Object.keys(params).length > 0) {

      const searchParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {

        if (value !== undefined && value !== null) {

          searchParams.append(key, value.toString());

        }

      });

      const queryString = searchParams.toString();

      if (queryString) {

        fullRouteToEncrypt = fullRouteToEncrypt.includes('?')

          ? `${fullRouteToEncrypt}&${queryString}`

          : `${fullRouteToEncrypt}?${queryString}`;

      }

    }

    let url;
    if (isApiEncryptionEnabled()) {
      const encryptedPath = await encryptData(fullRouteToEncrypt);
      url = `${BASE_URL}/gateway/${encryptedPath}`;
    } else {
      url = `${BASE_URL}/gateway/${fullRouteToEncrypt}`;
    }

    let requestHeaders = {

      "Content-Type": "application/json",

      ...(token && { Authorization: `Bearer ${token}` }),

      ...headers

    };

    let requestBody = null;

    if ((method === 'POST' || method === 'PUT' || method === 'PATCH') && body) {

      if (body instanceof FormData) {

        requestBody = body;

        delete requestHeaders['Content-Type'];

      } else {

        const bodyString = JSON.stringify(body);
        requestBody = isApiEncryptionEnabled()
          ? await encryptData(bodyString)
          : bodyString;

      }

    }

    const config = {

      method,

      headers: requestHeaders,

      signal: controller.signal,

      ...(requestBody && { body: requestBody })

    };

    const res = await fetch(url, config);

    clearTimeout(id);

    // ================= 🚨 ENHANCED ERROR HANDLING =================

    if (!res.ok) {

      // 401 HANDLING (same logic but improved)

      if (res.status === 401) {

        const isLoginRequest =

          endpoint.includes('/login') ||

          endpoint.includes('/signin') ||

          endpoint.includes('/session-challenge');

        if (!isLoginRequest) {

          const { performUnauthorizedLogout, isLogoutInProgress } =
            await import('./logoutService');

          if (!isLogoutInProgress()) {
            performUnauthorizedLogout('401');
          }

          return;

        }

      }

      let errorText = await res.text();

      let errorMessage = `API Error: ${res.status}`;

      let errorCode;

      if (isApiEncryptionEnabled()) {
        try {
          errorText = await decryptData(errorText);
        } catch (decryptErr) {
          console.warn("Decrypt failed, using raw error:", decryptErr);
        }
      }

      try {

        const errorJson = typeof errorText === 'string' ? JSON.parse(errorText) : errorText;

        if (errorJson.code != null) {

          errorCode = String(errorJson.code);

        }

        if (errorJson.response?.response) {

          errorMessage = errorJson.response.response;

        } else if (typeof errorJson.response === 'string') {

          errorMessage = errorJson.response;

        } else if (errorJson.message) {

          errorMessage = errorJson.message;

        } else if (errorJson.data?.message) {

          errorMessage = errorJson.data.message;

        } else if (errorJson.data?.response?.response) {

          errorMessage = errorJson.data.response.response;

        } else if (typeof errorJson.data?.response === 'string') {

          errorMessage = errorJson.data.response;

        } else if (errorJson.error) {

          if (

            errorJson.error.includes('Connection') ||

            errorJson.message?.includes('Connection')

          ) {

            errorMessage = 'Service is temporarily unavailable. Please try again later.';

          } else {

            errorMessage = errorJson.error;

          }

        }

      } catch (parseErr) {

        if (

          typeof errorText === 'string' &&

          (

            errorText.includes('Connection refused') ||

            errorText.includes('ECONNREFUSED') ||

            errorText.includes('getsockopt')

          )

        ) {

          errorMessage = 'Service is temporarily unavailable. Please try again later.';

        } else if (typeof errorText === 'string' && errorText.length < 200) {

          errorMessage = errorText;

        }

      }

      const apiErr = new Error(errorMessage);

      apiErr.status = res.status;

      if (errorCode) apiErr.code = errorCode;

      throw apiErr;

    }

    // ================= RESPONSE DECRYPTION (UNCHANGED) =================

    const responseText = await res.text();

    if (!isApiEncryptionEnabled()) {
      if (!responseText) return null;
      try {
        return JSON.parse(responseText);
      } catch {
        return responseText;
      }
    }

    let responseData;
    try {
      const decryptedString = await decryptData(responseText);
      if (typeof decryptedString === "string") {
        try {
          responseData = JSON.parse(decryptedString);
        } catch {
          responseData = decryptedString;
        }
      } else {
        responseData = decryptedString;
      }
    } catch (decryptErr) {
      try {
        responseData = JSON.parse(responseText);
      } catch {
        throw new Error("Failed to decrypt response: " + decryptErr.message);
      }
    }

    return responseData;

  } catch (err) {

    clearTimeout(id);

    // ⏱ Timeout handling

    if (err.name === "AbortError") {

      throw new Error("Request timeout. Please try again.");

    }

    // 🌐 Network errors

    if (err.message && (

      err.message.includes('Connection refused') ||

      err.message.includes('ECONNREFUSED') ||

      err.message.includes('Failed to fetch') ||

      err.message.includes('NetworkError') ||

      err.message.includes('getsockopt')

    )) {

      throw new Error('Service is temporarily unavailable. Please check your connection and try again later.');

    }

    // 🧠 JSON error string handling

    if (err.message && (err.message.startsWith('{') || err.message.startsWith('['))) {

      try {

        const parsed = JSON.parse(err.message);

        if (parsed.message) throw new Error(parsed.message);

        if (parsed.error) throw new Error(parsed.error);

      } catch { }

    }

    throw err;

  }

}

// wrappers (unchanged)

export const apiGet = (endpoint, params) => apiRequest(endpoint, { method: "GET", params });

export const apiPost = (endpoint, body, options = {}) => apiRequest(endpoint, { method: "POST", body, ...options });

export const apiPut = (endpoint, body, options = {}) => apiRequest(endpoint, { method: "PUT", body, ...options });

export const apiDelete = (endpoint, options = {}) => apiRequest(endpoint, { method: "DELETE", ...options });

export const ticketGet = (endpoint, params) => apiRequest(endpoint, { method: "GET", params });

export const ticketPost = (endpoint, body, options = {}) => apiRequest(endpoint, { method: "POST", body, ...options });

export const ticketPut = (endpoint, body, options = {}) => apiRequest(endpoint, { method: "PUT", body, ...options });

export const ticketDelete = (endpoint, options = {}) => apiRequest(endpoint, { method: "DELETE", ...options });

// ================= CHATBOT URL HELPERS =================
// Encrypted (flag true): /chatbot/enc/<cipher> with CHATBOT_API_ENCRYPTION_KEY
// Plain (flag false): /chatbot/api/... or /chatbot/{email}/{userId}/...

export const getChatbotBaseUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
    return `https://kemis-helpdesk-pro.dhanushinfotech.com`;
    // return `https://helpdesk-pro.dhanushinfotech.com`;
  }
  return `${protocol}//${hostname}`;
};

/**
 * Encrypt a chatbot API path segment (e.g. api/user@x.com/1/2/3?embed=compact).
 * @param {string} apiPath - Route to encrypt (no leading slash)
 * @returns {Promise<string>} URL-encoded Base64 cipher for /chatbot/enc/<cipher>
 */
export async function encryptChatbotApiPath(apiPath) {
  const normalized = apiPath.startsWith("/") ? apiPath.substring(1) : apiPath;
  const cipher = await encryptChatbotData(normalized);
  return encodeURIComponent(cipher);
}

/**
 * Build chatbot URL (encrypted or plain per REACT_APP_ENABLE_API_ENCRYPTION).
 * @param {string} apiPath - e.g. api/ticket/summary
 */
export async function buildChatbotUrl(apiPath) {
  const base = getChatbotBaseUrl();
  const normalized = apiPath.startsWith("/") ? apiPath.substring(1) : apiPath;
  if (isApiEncryptionEnabled()) {
    const cipher = await encryptChatbotApiPath(normalized);
    return `${base}/chatbot/enc/${cipher}`;
  }
  return `${base}/chatbot/${normalized}`;
}

/** @deprecated Use buildChatbotUrl */
export const buildChatbotEncryptedUrl = buildChatbotUrl;

export async function getChatbotEmbedUrl({
  email,
  userId,
  tenantId,
  roleId,
  embed = "compact",
} = {}) {
  const base = getChatbotBaseUrl();
  if (isApiEncryptionEnabled()) {
    return buildChatbotUrl(
      `api/${email}/${userId}/${tenantId}/${roleId}?embed=${embed}`
    );
  }
  return `${base}/chatbot/api/${email}/${userId}/${tenantId}/${roleId}?embed=${embed}`;
}

export async function getChatbotTicketSummaryUrl() {
  return buildChatbotUrl("api/ticket/summary");
}

export async function getChatbotGenerateArticleUrl() {
  return buildChatbotUrl("api/ticket/generate-article");
}

function getChatbotAuthHeaders(extra = {}) {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    localStorage.getItem("authToken");
  return {
    ...(token && { Authorization: `Bearer ${token}` }),
    ...extra,
  };
}

/**
 * GET /chatbot/enc/{cipher} — response body is AES-GCM ciphertext; returns decrypted text/HTML.
 */
export async function fetchDecryptedChatbotPage(encryptedUrl) {
  const res = await fetch(encryptedUrl, {
    method: "GET",
    headers: getChatbotAuthHeaders(),
  });

  if (!res.ok) {
    const errText = await res.text().catch(() => "");
    throw new Error(errText || `Chatbot request failed (${res.status})`);
  }

  const body = (await res.text()).trim();
  if (!isApiEncryptionEnabled()) {
    return body;
  }
  try {
    return await decryptChatbotData(body, { parseJson: false });
  } catch {
    return body;
  }
}

/** Decrypt chatbot API response (JSON or plain text). */
export async function parseChatbotApiResponse(response) {
  const body = (await response.text()).trim();
  if (!body) return {};
  if (!isApiEncryptionEnabled()) {
    try {
      return JSON.parse(body);
    } catch {
      return body;
    }
  }
  try {
    return await decryptChatbotData(body, { parseJson: true });
  } catch {
    try {
      return JSON.parse(body);
    } catch {
      return body;
    }
  }
}

/**
 * POST to chatbot route; encrypts body + decrypts response when ENABLE_API_ENCRYPTION is true.
 */
export async function chatbotApiPost(apiPath, body, { headers = {} } = {}) {
  const url = await buildChatbotUrl(apiPath);
  const bodyString = JSON.stringify(body);
  const requestBody = isApiEncryptionEnabled()
    ? await encryptChatbotData(bodyString)
    : bodyString;

  const res = await fetch(url, {
    method: "POST",
    headers: getChatbotAuthHeaders({
      "Content-Type": "application/json",
      ...headers,
    }),
    body: requestBody,
  });

  const data = await parseChatbotApiResponse(res);
  if (!res.ok) {
    const message =
      (typeof data === "object" && (data?.message || data?.error || data?.detail)) ||
      (typeof data === "string" ? data : `Chatbot API error (${res.status})`);
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

/** Embed HTML for iframe srcDoc (resolves relative assets against chatbot origin). */
export function injectChatbotDocumentBase(html) {
  const baseHref = `${getChatbotBaseUrl()}/`;
  if (/<base\s/i.test(html)) {
    return html;
  }
  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head[^>]*>/i, `$&<base href="${baseHref}">`);
  }
  return `<!DOCTYPE html><html><head><base href="${baseHref}"></head><body>${html}</body></html>`;
}

/**
 * Load chatbot embed for iframe.
 * @returns {{ srcDoc: string|null, iframeSrc: string|null }}
 *   - Encrypted: srcDoc with decrypted HTML
 *   - Plain: iframeSrc with direct /chatbot/{email}/... URL
 */
export async function loadChatbotEmbedDocument({
  email,
  userId,
  tenantId,
  roleId,
  embed = "compact",
} = {}) {
  const iframeSrc = await getChatbotEmbedUrl({
    email,
    userId,
    tenantId,
    roleId,
    embed,
  });

  if (!isApiEncryptionEnabled()) {
    return { srcDoc: null, iframeSrc };
  }

  const html = await fetchDecryptedChatbotPage(iframeSrc);
  return { srcDoc: injectChatbotDocumentBase(html), iframeSrc: null };
}

export { CHATBOT_API_ENCRYPTION_KEY };
